import { DefaultButton } from "@bps/fluent-ui";
import { OpsReportDefinition } from "@libs/api/gateways/plt-reports-ops/plt-reports-ops-gateway.dtos";
import {
  usePostOpsReportRefresh,
  useOpsReportsWritePermissionsQuery
} from "@libs/api/gateways/plt-reports-ops/plt-reports-ops-gateway.hooks";
import { NO_ACTION_PERMISSION } from "@libs/permissions/permissions.constants";

interface RefreshReportButtonProps {
  report: OpsReportDefinition;
}

export const RefreshReportButton = ({ report }: RefreshReportButtonProps) => {
  const { data: hasWritePermission } = useOpsReportsWritePermissionsQuery();
  const refreshReport = usePostOpsReportRefresh(report.name);

  const onRefreshClick = e => {
    e.preventDefault();
    refreshReport.mutate();
  };

  return (
    <DefaultButton
      iconProps={{ iconName: "Refresh" }}
      onClick={onRefreshClick}
      disabled={!hasWritePermission || refreshReport.isLoading}
      title={!hasWritePermission ? NO_ACTION_PERMISSION : undefined}
      styles={{
        root: { width: 150 }
      }}
    >
      Refresh
    </DefaultButton>
  );
};
